"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var storage_1 = require("./storage");
var DEFAULT_COUNT_PER_INTERVAL = 10;
var DEFAULT_INTERVAL = 60;
var FloodGuard = (function () {
    function FloodGuard(options, storage) {
        if (storage === void 0) { storage = storage_1.Storage.getInstance(); }
        this.storage = storage;
        this.countPerInterval = DEFAULT_COUNT_PER_INTERVAL;
        this.interval = DEFAULT_INTERVAL;
        this.event = 'default';
        this.event = options.event;
        if (options.interval) {
            this.interval = options.interval;
        }
        if (options.countPerInterval) {
            this.countPerInterval = options.countPerInterval;
        }
    }
    FloodGuard.prototype.hasRemainingActions = function () {
        var _this = this;
        var currentEpoch = new Date().getTime() / 1000;
        var event = this.event;
        var entries = this.storage.get(event).filter(function (seconds) {
            return currentEpoch - seconds <= _this.interval;
        });
        if (entries.length >= this.countPerInterval) {
            return false;
        }
        entries.push(currentEpoch);
        this.storage.set(event, entries, this.interval);
        return true;
    };
    return FloodGuard;
}());
exports.default = FloodGuard;
